import { useEffect } from 'react';

const usePageTitle = (title?: string): void => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('utm_campaign')) {
      const partnerTitle = params.get('utm_campaign');
      if (partnerTitle) {
        document.title = partnerTitle;
      }
    } else {
      if (title) {
        document.title = `Kindred for Business - ${title}`;
      } else {
        document.title = 'Kindred for Business';
      }
    }
  }, [title]);
};

export default usePageTitle;
